import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { IdentityActions } from './identity.actions';

@Injectable({
  providedIn: 'root'
})
export class IdentityEffects {
  sendIdentityEffect$: Observable<Action> = createEffect(
    (): any =>
      this.actions$.pipe(
        ofType(IdentityActions.submitSuccess),
        tap(() => {})
      ),
    { dispatch: false }
  );

  constructor(private actions$: Actions) {}
}
